import React, { useState, useEffect } from "react"
import styled from "styled-components"
import List from "../ui/list"
import ReactMapboxGl, { Marker } from "react-mapbox-gl";
import Pin from "../../images/Map-pin.svg"
import 'mapbox-gl/dist/mapbox-gl.css';

const Section = styled.section`
//   padding: 5rem 0 5rem;
//   min-height: 65vh;
  background-color: ${(props) => props.theme.colors.white};
  svg {
    width: 70px;
    .cls-2 {
        mask: none;
    }
  }
  

  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding: 0 0 5rem;
  }
  li:before {
    display: none;  
  }
  a {
    text-decoration: none;
  }

  h3 {
    color: ${(props) => props.theme.colors.primary};
    font-size: 30px;
    font-family: ${(props) => props.theme.fontBold};
    margin-bottom: 1rem;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
      font-size: 25px;
    }
    &.strike {
      position: relative;
      width: fit-content;
      z-index: 1;
    }
    &.strike:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 5px;
      @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
        height: 3px;
      }
      bottom: 6px;
      left: 2px;
      background-color: ${(props) => props.theme.colors.secondary};
      visibility: visible;
      //animation: 1.2s ease-out 0s 1 slideInFromLeft;
      // animation-duration: 0.8s; /* the duration of the animation */
      // animation-timing-function: ease-in; /* how the animation will behave */
      // animation-delay: 0s; /* how long to delay the animation from starting */
      // animation-iteration-count: 1; /* how many times the animation will play */
      // animation-name: slideInFromLeft; /* the name of the animation we defined above */
      // transition: all 0.2s ease-in-out;
      z-index: -1;
    }
    &.strike:hover:before {
      visibility: visible;
      width: 100%;
    }
    // @keyframes slideInFromLeft {
    //   0% {
    //     width: 0;
    //   }
    //   100% {
    //     visibility: visible;
    //     width: 100%;
    //   }
    // }
  }
  span {
    font-family: ${(props) => props.theme.fontBold};
  }
  p {
    margin-top: 0;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
      font-size: 16px;
    }
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 5%;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    max-width: 100%;
    padding: 0;
  }
`;


const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`;

const ContactInfo = styled.div`
  padding-left: 4rem;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding-left: 0;
    max-width: 90%;
    margin: 0 auto;
  }
`;

const ContactRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    display: inline-flex;
    width: 50%;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
    display: flex;
    width: 100%;
  }
`;

const MapContainer = styled.div`
  
`;

const Left = styled.div`
  width: 48%;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    width: 60%;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 100%;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
    width: 100%;
  }
`;

const Right = styled.div`
  width: 48%;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    width: 40%;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 100%;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
    width: 100%;
  }
`;


// Window Width Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

const Map = () => {

  
  const size = useWindowSize();

  if (size.width <= 576) {
    var mapHeight = "300px";
    var touch = false
  } else if (size.width > 576 && size.width <= 768) {
    var mapHeight = "400px";
    var touch = false;
  } else {
    var mapHeight = "600px";
    var touch = true;
  }
  const Map = ReactMapboxGl({
    minZoom: 8,
    maxZoom: 15,
    interactive: touch,
    accessToken: "pk.eyJ1Ijoia3lsZTNtaCIsImEiOiJja29yaGR5YXMxMzQwMnVzenYya2FseDNmIn0.3Pls1lCDEE-tNbW3KVUQhg",
  });

  

  return (
    <Section id="map">
          <MapContainer>
              <Map
                style="mapbox://styles/mapbox/light-v10"
                containerStyle={{
                  height: mapHeight,
                  width: "100%",
                }}
                center={[-0.2265259, 51.5039681]}
                zoom={[14]}
              >
                <Marker coordinates={[-0.2265259, 51.5039681]} anchor="bottom">
                  <Pin />
                </Marker>
              </Map>
            </MapContainer>
    </Section>
  );
};

export default Map
